import { type FC } from 'react';
import {
  X
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconXProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconX: FC<UiIconXProps> = (props) => {
  return (
    <UiIcon
      IconComponent={X}
      {...props}
    />
  );
};
